import { render, staticRenderFns } from "./updata.vue?vue&type=template&id=19bdd78a&scoped=true"
import script from "./updata.vue?vue&type=script&lang=js"
export * from "./updata.vue?vue&type=script&lang=js"
import style0 from "./updata.vue?vue&type=style&index=0&id=19bdd78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bdd78a",
  null
  
)

export default component.exports